<form class="d-xl-flex d-none">
  <div class="form-inner">
    <input
      type="text"
      [(ngModel)]="searchTerm"
      name="search"
      [placeholder]="'horse_view.search_horses' | translate"
      (keyup)="onInputChange()"
      (paste)="onPaste()"
      (click)="onSearchClick()"
      autocomplete="off"
      class="search--input"
      data-translation-key="horse_view_search_horses"
      />
      <button class="search-btn" type="button" (click)="onSearch()">
        @if (!isLoading) {
          <mat-icon>search</mat-icon>
        }
        @if (isLoading) {
          <div class="search-loading">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
            </div>
          </div>
        }
      </button>

      <!-- Desktop Dropdown Results -->
      @if (showResults) {
        <div
          class="search-results-dropdown"
          (scroll)="onResultsScroll($event)"
          >
          @if (
            searchResults.length == 0 && !isLoading && searchTerm.length >= 3
            ) {
            <div
              class="no-results"
              >
              <p data-translation-key="buyer_header_no_result">
                {{ 'buyer_header.no_result' | translate }} "{{ searchTerm }}"
              </p>
            </div>
          }
          @if (!isLoading && searchResults.length > 0) {
            <ul class="results-list">
              @for (item of searchResults; track item) {
                <li (click)="selectItem(item)">
                  <div class="result-wrapper">
                    <div class="result-item">
                      @if (item.imageUrl) {
                        <img
                          [src]="item.imageUrl"
                          alt="{{ item.name }}"
                          class="result-thumbnail"
                          />
                      }
                      <div class="result-info">
                        <div class="result-name">
                          <span>#</span><span>{{ item?.hip_number }}</span>
                          <span>{{ item.name }}</span>
                        </div>
                        @if (item.auction_name) {
                          <div class="result-details">
                            {{ item.auction_name | localizedName }}
                          </div>
                        }
                      </div>
                    </div>
                    <span
                      class="status {{ item.status }}"
              [attr.data-translation-key]="
                item?.status == 'active'
                  ? 'auction_active_auction'
                  : item?.status == 'previous'
                  ? 'auction_previous_auction'
                  : 'auction_upcoming_auction'
              "
                      >
                      @if (item?.status == 'active') {
                        {{ 'auction.active_auction' | translate }}
                      }
                      @if (item?.status == 'previous') {
                        {{ 'auction.previous_auction' | translate }}
                      }
                      @if (item?.status == 'upcoming') {
                        {{ 'auction.upcoming_auction' | translate }}
                      }
                    </span>
                  </div>
                </li>
              }
            </ul>
          }
          @if (hasMoreResults) {
            <div class="dropdown-footer">
              <button type="button" [disabled]="isLoadingMore">
                @if (isLoadingMore) {
                  <div
                    class="spinner-border spinner-border-sm"
                    role="status"
                    >
                    <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                  </div>
                }
              </button>
            </div>
          }
        </div>
      }
    </div>
  </form>
  <!-- Tablet Search - LG screens -->
  <div class="search-bar d-none d-lg-block d-xl-none">
    <div class="search-btn" (click)="toggleSearch()">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.67458 2.95934C5.06925 2.95934 2.95925 5.06868 2.95925 7.66868C2.95925 10.2687 5.06925 12.3773 7.67458 12.3773C8.97459 12.3773 10.1499 11.8533 11.0033 11.004C11.4434 10.5674 11.7926 10.0477 12.0307 9.47524C12.2687 8.90273 12.3908 8.28869 12.3899 7.66868C12.3899 5.06868 10.2799 2.95934 7.67458 2.95934ZM1.33325 7.66868C1.33325 4.16868 4.17325 1.33334 7.67458 1.33334C11.1759 1.33334 14.0159 4.16868 14.0159 7.66868C14.0178 9.07185 13.5516 10.4356 12.6913 11.544L14.4279 13.2787C14.5084 13.353 14.573 13.4427 14.618 13.5426C14.6629 13.6424 14.6872 13.7503 14.6894 13.8598C14.6916 13.9693 14.6717 14.0781 14.6309 14.1797C14.59 14.2813 14.5291 14.3736 14.4517 14.4511C14.3743 14.5286 14.2821 14.5896 14.1805 14.6306C14.079 14.6716 13.9702 14.6916 13.8607 14.6895C13.7512 14.6874 13.6433 14.6632 13.5434 14.6184C13.4435 14.5736 13.3536 14.5091 13.2793 14.4287L11.5393 12.6913C10.4316 13.544 9.07244 14.0054 7.67458 14.0033C4.17325 14.0033 1.33325 11.168 1.33325 7.66868Z"
          />
        </svg>
      </div>
      <div class="search-input" [class.active]="isSearchOpen">
        <div class="search-close" (click)="toggleSearch()"></div>
        <form>
          <div class="search-group">
            <div class="form-inner2">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="searchTerm"
                name="search-tablet"
                [placeholder]="'horse_view.search_horses' | translate"
                (keyup)="onInputChange()"
                (paste)="onPaste()"
                (click)="onSearchClick()"
                autocomplete="off"
                data-translation-key="horse_view_search_horses"
                />
                <button type="submit" (click)="onSearch()">
                  @if (!isLoading) {
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.67458 2.95934C5.06925 2.95934 2.95925 5.06868 2.95925 7.66868C2.95925 10.2687 5.06925 12.3773 7.67458 12.3773C8.97459 12.3773 10.1499 11.8533 11.0033 11.004C11.4434 10.5674 11.7926 10.0477 12.0307 9.47524C12.2687 8.90273 12.3908 8.28869 12.3899 7.66868C12.3899 5.06868 10.2799 2.95934 7.67458 2.95934ZM1.33325 7.66868C1.33325 4.16868 4.17325 1.33334 7.67458 1.33334C11.1759 1.33334 14.0159 4.16868 14.0159 7.66868C14.0178 9.07185 13.5516 10.4356 12.6913 11.544L14.4279 13.2787C14.5084 13.353 14.573 13.4427 14.618 13.5426C14.6629 13.6424 14.6872 13.7503 14.6894 13.8598C14.6916 13.9693 14.6717 14.0781 14.6309 14.1797C14.59 14.2813 14.5291 14.3736 14.4517 14.4511C14.3743 14.5286 14.2821 14.5896 14.1805 14.6306C14.079 14.6716 13.9702 14.6916 13.8607 14.6895C13.7512 14.6874 13.6433 14.6632 13.5434 14.6184C13.4435 14.5736 13.3536 14.5091 13.2793 14.4287L11.5393 12.6913C10.4316 13.544 9.07244 14.0054 7.67458 14.0033C4.17325 14.0033 1.33325 11.168 1.33325 7.66868Z"
                        />
                      </svg>
                    }
                    @if (isLoading) {
                      <div class="search-loading">
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                        </div>
                      </div>
                    }
                  </button>
                  @if (showResults) {
                    <div
                      class="search-results-dropdown tablet-results"
                      (scroll)="onResultsScroll($event)"
                      >
                      @if (
                        searchResults.length == 0 &&
                        !isLoading &&
                        searchTerm.length >= 3
                        ) {
                        <div
                          class="no-results"
                          >
                          <p data-translation-key="buyer_header_no_result">
                            {{ 'buyer_header.no_result' | translate }} "{{ searchTerm }}"
                          </p>
                        </div>
                      }
                      @if (!isLoading && searchResults.length > 0) {
                        <ul
                          class="results-list"
                          >
                          @for (item of searchResults; track item) {
                            <li (click)="selectItem(item)">
                              <div class="result-wrapper">
                                <div class="result-item">
                                  @if (item.imageUrl) {
                                    <img
                                      [src]="item.imageUrl"
                                      alt="{{ item.name }}"
                                      class="result-thumbnail"
                                      />
                                  }
                                  <div class="result-info">
                                    <div class="result-name">
                                      <span>#</span><span>{{ item?.hip_number }}</span>
                                      <span>{{ item.name }}</span>
                                    </div>
                                    @if (item.auction_name) {
                                      <div class="result-details">
                                        {{ item.auction_name }}
                                      </div>
                                    }
                                  </div>
                                </div>
                                <span
                                  class="status {{ item.status }}"
                    [attr.data-translation-key]="
                      item?.status == 'active'
                        ? 'auction_active_auction'
                        : item?.status == 'previous'
                        ? 'auction_previous_auction'
                        : 'auction_upcoming_auction'
                    "
                                  >
                                  @if (item?.status == 'active') {
                                    {{ 'auction.active_auction' | translate }}
                                  }
                                  @if (item?.status == 'previous') {
                                    {{ 'auction.previous_auction' | translate }}
                                  }
                                  @if (item?.status == 'upcoming') {
                                    {{ 'auction.upcoming_auction' | translate }}
                                  }
                                </span>
                              </div>
                            </li>
                          }
                        </ul>
                      }
                      @if (hasMoreResults) {
                        <div class="dropdown-footer">
                          <button type="button" [disabled]="isLoadingMore">
                            @if (isLoadingMore) {
                              <div
                                class="spinner-border spinner-border-sm"
                                role="status"
                                >
                                <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                              </div>
                            }
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- Mobile Search -->
        <form class="d-lg-none d-xl-none d-flex">
          <div class="form-inner">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="searchTerm"
              name="search-mobile"
              [placeholder]="'horse_view.search_horses' | translate"
              (keyup)="onInputChange()"
              (paste)="onPaste()"
              (click)="onSearchClick()"
              autocomplete="off"
              data-translation-key="horse_view_search_horses"
              />
              <button class="search-btn" type="button" (click)="onSearch()">
                @if (!isLoading) {
                  <mat-icon>search</mat-icon>
                }
                @if (isLoading) {
                  <div class="search-loading">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                    </div>
                  </div>
                }
              </button>
              @if (showResults) {
                <div
                  class="search-results-dropdown mobile-results"
                  (scroll)="onResultsScroll($event)"
                  >
                  @if (
                    searchResults.length == 0 && !isLoading && searchTerm.length >= 3
                    ) {
                    <div
                      class="no-results"
                      >
                      <p data-translation-key="buyer_header_no_result">
                        {{ 'buyer_header.no_result' | translate }} "{{ searchTerm }}"
                      </p>
                    </div>
                  }
                  @if (!isLoading && searchResults.length > 0) {
                    <ul class="results-list">
                      @for (item of searchResults; track item) {
                        <li (click)="selectItem(item)">
                          <div class="result-wrapper">
                            <div class="result-item">
                              @if (item.imageUrl) {
                                <img
                                  [src]="item.imageUrl"
                                  alt="{{ item.name }}"
                                  class="result-thumbnail"
                                  />
                              }
                              <div class="result-info">
                                <div class="result-name">
                                  <span>#</span><span>{{ item?.hip_number }}</span>
                                  <span>{{ item.name }}</span>
                                </div>
                                @if (item.auction_name) {
                                  <div class="result-details">
                                    {{ item.auction_name | localizedName }}
                                  </div>
                                }
                              </div>
                            </div>
                            <span
                              class="status {{ item.status }}"
              [attr.data-translation-key]="
                item?.status == 'active'
                  ? 'auction_active_auction'
                  : item?.status == 'previous'
                  ? 'auction_previous_auction'
                  : 'auction_upcoming_auction'
              "
                              >
                              @if (item?.status == 'active') {
                                {{ 'auction.active_auction' | translate }}
                              }
                              @if (item?.status == 'previous') {
                                {{ 'auction.previous_auction' | translate }}
                              }
                              @if (item?.status == 'upcoming') {
                                {{ 'auction.upcoming_auction' | translate }}
                              }
                            </span>
                          </div>
                        </li>
                      }
                    </ul>
                  }
                  @if (hasMoreResults) {
                    <div class="dropdown-footer">
                      <button type="button" [disabled]="isLoadingMore">
                        @if (isLoadingMore) {
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                            >
                            <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
                          </div>
                        }
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </form>
